import { FC } from 'react';
import { TeamUtilizationBarChartContainer } from '../TeamUtilizationBarChart/TeamUtilizationBarChartContainer';
import { TeamMemberStatsContainer } from '../TeamMemberStatsContainer/TeamMemberStatsContainer';

export const TeamUtilizationContainer: FC<{
  teamId: number;
}> = ({ teamId }) => {
  return (
    <>
      <TeamUtilizationBarChartContainer teamId={teamId} />
      <TeamMemberStatsContainer teamId={teamId} />
    </>
  );
};
